import { RequireRole } from '@/components/RequireRole';
import { Admin } from '@/routes/Admin';
import { NotFound } from '@/routes/NotFound';
import { Review } from '@/routes/Review';
import { Upload } from '@/routes/Upload';
import type { FC } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

/**
 * The routes of the application.
 *
 * Every one of them is private: the sign-in gate wraps the whole app in `main.tsx`, so an
 * unauthenticated visitor sees the sign-in screen instead of any route. The admin section has one
 * route per view; addresses of the removed technical configuration fall back to `/admin`.
 */
const App: FC = () => (
  <Routes>
    <Route path="/" element={<Upload />} />
    <Route path="/documents/:documentId" element={<Review />} />
    <Route
      path="/admin"
      element={
        <RequireRole requiredRole="app-admin">
          <Outlet />
        </RequireRole>
      }
    >
      <Route index={true} element={<Admin view="categories" />} />
      <Route path="items" element={<Admin view="items" />} />
      <Route path="system-prompt" element={<Admin view="system" />} />
      <Route path="*" element={<Navigate to="/admin" replace={true} />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default App;
